import React from 'react';
import classNames from 'classnames';

import css from './IconRule.module.css';

/**
 * IconRule icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconRule = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg className={classes} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M9.66082 2.78023C10.0828 2.35842 10.6549 2.12146 11.2516 2.12146C11.8482 2.12146 12.4204 2.35842 12.8423 2.78023L15.2213 5.15923C15.6431 5.58117 15.8801 6.15336 15.8801 6.74998C15.8801 7.3466 15.6431 7.91879 15.2213 8.34073L8.34232 15.2197C7.92038 15.6415 7.34819 15.8785 6.75157 15.8785C6.15495 15.8785 5.58275 15.6415 5.16082 15.2197L2.78182 12.84C2.36001 12.418 2.12305 11.8458 2.12305 11.2492C2.12305 10.6526 2.36001 10.0804 2.78182 9.65848L3.44107 8.99998L4.72132 10.2802C4.86277 10.4168 5.05222 10.4924 5.24887 10.4907C5.44552 10.489 5.63362 10.4101 5.77268 10.2711C5.91174 10.132 5.99061 9.94393 5.99232 9.74728C5.99403 9.55063 5.91844 9.36118 5.78182 9.21973L4.50157 7.93948L5.69107 6.74998L7.72132 8.78023C7.86277 8.91685 8.05222 8.99244 8.24887 8.99074C8.44551 8.98903 8.63362 8.91015 8.77268 8.77109C8.91174 8.63204 8.99061 8.44393 8.99232 8.24728C8.99403 8.05063 8.91844 7.86118 8.78182 7.71973L6.75157 5.68948L7.94107 4.49998L9.22132 5.78023C9.2905 5.85186 9.37326 5.909 9.46476 5.94831C9.55627 5.98761 9.65468 6.0083 9.75427 6.00917C9.85385 6.01003 9.95261 5.99106 10.0448 5.95335C10.137 5.91564 10.2207 5.85995 10.2911 5.78953C10.3615 5.71911 10.4172 5.63537 10.4549 5.5432C10.4926 5.45102 10.5116 5.35226 10.5108 5.25268C10.5099 5.15309 10.4892 5.05468 10.4499 4.96318C10.4106 4.87167 10.3534 4.78891 10.2818 4.71973L9.00157 3.43948L9.66082 2.78023Z" fill="#262338"/>
    </svg>


  );
};

export default IconRule;
